import React from "react";
import { NavLink } from "react-router-dom";
import {
  RiHome5Line,
  RiHome5Fill,
  RiWeightLine,
  RiLineChartLine,
  RiLeafLine,
  RiUserLine,
} from "react-icons/ri";
import "./BottomNav.css";

const ITEMS = [
  { path: "/dashboard", label: "Home", icon: RiHome5Line, activeIcon: RiHome5Fill },
  { path: "/exercises", label: "Workout", icon: RiWeightLine },
  { path: "/analytics", label: "Progress", icon: RiLineChartLine },
  { path: "/diet", label: "Nutrition", icon: RiLeafLine },
  { path: "/profile", label: "Profile", icon: RiUserLine },
];

const BottomNav = () => (
  <nav className="curated-bottom-nav" aria-label="Primary">
    {ITEMS.map(({ path, label, icon: Icon, activeIcon: ActiveIcon }) => (
      <NavLink
        key={path}
        to={path}
        end={path === "/dashboard"}
        className={({ isActive }) =>
          `curated-bottom-nav-item ${isActive ? "curated-bottom-nav-item--active" : ""}`
        }
      >
        {({ isActive }) => (
          <>
            {isActive && ActiveIcon ? <ActiveIcon size={22} /> : <Icon size={22} />}
            <span>{label}</span>
          </>
        )}
      </NavLink>
    ))}
  </nav>
);

export default BottomNav;
